module.exports = __webpack_public_path__ + "images/help_v2/avatars/gavin-c0c762fe78d6e41cd840cd6210cf1df8.png";